import { useState, useEffect, useRef } from 'react';
import PaginationGrid from './PaginationGrid';
import Select from 'react-select';
import { ReactComponent as Search } from "./Image/search.svg";
import { ReactComponent as CSV } from "./Image/csv.svg";
import { ReactComponent as Excel } from "./Image/excel.svg";
import logo from './Yeonoo/yeonoo_logo.png';
import { backgroundMainColor } from './Color';
//import * as XLSX from "xlsx";
//import Papa from "papaparse";
import { ApiGet } from './Function';
//import Popup from './Popup';

function GwangjuRawData({ bizUnit=1 }) { 
  const mainUrl = { 2: '#/anseong', 3: '#/gwangju', 4: '#/gumi' };
  const countType = [ { value: 'count', label: '카운트' } ];
  const temperatureType = [ { value: 'molding-oven-temperature', label: '온도' } ];
  const continuousRoad = [ { value: 'continuous-road-tic', label: 'TIC' }, { value: 'count', label: '카운트' } ];
  const gaapType = [ 
    { value: 'gaap-alarm', label: '알림' }, 
    { value: 'gaap-value', label: '상하부램, 압력, 온도, 진공' }
  ];
  const testType = [ 
    { value: 'electricity', label: '전력량' }, 
    { value: 'current', label: '전류' }
  ];
  const testType2 = [ 
    { value: 'CO2', label: 'CO2' }
  ];
  const equipmentOptionDictionary = {
    1: [
      { value: 'Yeonoo', label: '전체', dataType: testType2 },
      { value: 'Infra room', label: '인프라팀', dataType: testType },
      { value: 'Server', label: '서버', dataType: testType },
      { value: 'A/C', label: '에어컨', dataType: testType },
    ],
    2: [
      //안성
      { value: 'CNC양면1호기', label: 'CNC양면1호기', dataType: countType }, //카운트
      { value: 'CNC양면2호기', label: 'CNC양면2호기', dataType: countType },
      { value: 'CNC양면3호기', label: 'CNC양면3호기', dataType: countType },
      { value: 'CNC수직1호기', label: 'CNC수직1호기', dataType: countType }, //카운트
      { value: 'CNC수직2호기', label: 'CNC수직2호기', dataType: countType },
      { value: 'CNC수직3호기', label: 'CNC수직3호기', dataType: countType },
      { value: '로봇용접기', label: '로봇용접기', dataType: countType }, //카운트
      { value: '성형오븐1호기', label: '성형오븐1호기', dataType: temperatureType }, //온도
      { value: '성형오븐2호기', label: '성형오븐2호기', dataType: temperatureType },
      { value: '2500톤 프레스', label: '2500톤 프레스', dataType: countType },
    ],  
    3: [
      //광주
      { value: '연속로 1호기', label: '연속로 1호기', dataType: continuousRoad }, //카운트, TIC
      { value: '연속로 2호기', label: '연속로 2호기', dataType: continuousRoad },
      { value: '연속로 3호기', label: '연속로 3호기', dataType: continuousRoad },
      { value: '연속로 4호기', label: '연속로 4호기', dataType: continuousRoad },
      { value: '30톤 프레스 1호기', label: '30톤 프레스 1호기', dataType: countType }, //카운트
      { value: '30톤 프레스 2호기', label: '30톤 프레스 2호기', dataType: countType },
      { value: '30톤 프레스 3호기', label: '30톤 프레스 3호기', dataType: countType },
      { value: '30톤 프레스 4호기', label: '30톤 프레스 4호기', dataType: countType },
      { value: '30톤 프레스 5호기', label: '30톤 프레스 5호기', dataType: countType },
      { value: '250톤 유압프레스', label: '250톤 유압프레스', dataType: countType }, //카운트
      { value: '프레스 450T %231', label: '프레스 450T #1', dataType: countType }, //카운트, # 뒤에는 서버에서 인식하지 못하므로 %23으로 대체
      { value: '요적자동화로봇', label: '요적자동화로봇', dataType: countType }, //카운트
    ],
    4: [
      //구미
      { value: '성형프레스1호기', label: '성형프레스1호기', dataType: countType }, //카운트
      { value: '성형프레스2호기', label: '성형프레스2호기', dataType: countType },
      { value: '성형프레스3호기', label: '성형프레스3호기', dataType: countType },
      { value: '성형프레스4호기', label: '성형프레스4호기', dataType: countType },
      { value: '성형프레스5호기', label: '성형프레스5호기', dataType: countType },
      { value: '성형프레스6호기', label: '성형프레스6호기', dataType: countType },
      { value: '연마재회수분급기', label: '연마재회수분급기', dataType: countType }, //카운트
      { value: '1번 가압대', label: '1번 가압대', dataType: gaapType }, //경보, 상부램, 하부램, 압력, 온도, 진공
      { value: '2번 가압대', label: '2번 가압대', dataType: gaapType },
      { value: '3번 가압대', label: '3번 가압대', dataType: gaapType },
      { value: '4번 가압대', label: '4번 가압대', dataType: gaapType },
      { value: '5번 가압대', label: '5번 가압대', dataType: gaapType },
      { value: '6번 가압대', label: '6번 가압대', dataType: gaapType },
      { value: '7번 가압대', label: '7번 가압대', dataType: gaapType },
      { value: '8번 가압대', label: '8번 가압대', dataType: gaapType },
      { value: '9번 가압대', label: '9번 가압대', dataType: gaapType },
      { value: '10번 가압대', label: '10번 가압대', dataType: gaapType },
      { value: '11번 가압대', label: '11번 가압대', dataType: gaapType },
      { value: '12번 가압대', label: '12번 가압대', dataType: gaapType },
      { value: '13번 가압대', label: '13번 가압대', dataType: gaapType },
      { value: '14번 가압대', label: '14번 가압대', dataType: gaapType },
      { value: '15번 가압대', label: '15번 가압대', dataType: gaapType },
      { value: '16번 가압대', label: '16번 가압대', dataType: gaapType },
      { value: '17번 가압대', label: '17번 가압대', dataType: gaapType },
      { value: '18번 가압대', label: '18번 가압대', dataType: gaapType },
      { value: '19번 가압대', label: '19번 가압대', dataType: gaapType },
      { value: '20번 가압대', label: '20번 가압대', dataType: gaapType },
      { value: '21번 가압대', label: '21번 가압대', dataType: gaapType },
      { value: '22번 가압대', label: '22번 가압대', dataType: gaapType },
      { value: '23번 가압대', label: '23번 가압대', dataType: gaapType },
      { value: '24번 가압대', label: '24번 가압대', dataType: gaapType },
      { value: '25번 가압대', label: '25번 가압대', dataType: gaapType },
      { value: '26번 가압대', label: '26번 가압대', dataType: gaapType },
      { value: '27번 가압대', label: '27번 가압대', dataType: gaapType },
      { value: '28번 가압대', label: '28번 가압대', dataType: gaapType },
      { value: '29번 가압대', label: '29번 가압대', dataType: gaapType },
      { value: '30번 가압대', label: '30번 가압대', dataType: gaapType },
      { value: '31번 가압대', label: '31번 가압대', dataType: gaapType },
      { value: '32번 가압대', label: '32번 가압대', dataType: gaapType },
      { value: '33번 가압대', label: '33번 가압대', dataType: gaapType },
      { value: '34번 가압대', label: '34번 가압대', dataType: gaapType },
    ]
  }
  const equipmentOptions = equipmentOptionDictionary[bizUnit];

  const [popup, setPopup] = useState(<></>);
  const [date, setDate] = useState({ start: GetDateTime(true), end: GetDateTime(false) });
  const [equipmentOption, setEquipmentOption] = useState();
  const [dataTypeOptions, setDataTypeOptions] = useState([]);
  const [dataTypeOption, setDataTypeOption] = useState();
  const [apiUrl, setApiUrl] = useState('');

  const equipmentSelectRef = useRef();
  const dataTypeSelectRef = useRef();

  useEffect(() => {
    document.title = 'Raw Data';

    //첫 데이터 기본으로 검색 조건으로 설정
    equipmentSelectRef.current.setValue(equipmentOptions[0]);
  }, []);

  function EquipmentSelectChange(option) {
    setEquipmentOption(() => {
      return option;
    });
    
    dataTypeSelectRef.current.setValue(option.dataType[0]);
    
    setDataTypeOptions(() => {
      return option.dataType;
    });
  }
  function DataTypeSelectChange(option) {
    setDataTypeOption(() => {
      return option;
    });
  }
  const searchStyles = {
    control: (provided) => ({
      ...provided,
      width: 200,
      height: 40,
    }),
    valueContainer: (base) => ({
      ...base,
      height: '100%',
      fontSize: '13px',
      padding: '0px',
      margin: '0px',
    }),
    menu: (provided) => ({
      ...provided,
      width: 200,
      borderColor: 'gray',
      borderWidth: '1px',
      borderStyle: 'solid',
      zIndex: 16,
    }),
    option: (provided) => ({
      ...provided,
      fontSize: '13px',
      height: 40,
      padding: '0px',
      margin: '0px',
      display: 'flex',
      alignItems: 'center',
    }),
    input: (provided) => ({
      ...provided,
      padding: '0px',
      margin: '0px',
    }),
  };

  function DateOnChange(event) {
    setDate((previous) => {
      if (event.target.id === 'start') {
        return { ...previous, start: event.target.value };
      } else if (event.target.id === 'end') {
        return { ...previous, end: event.target.value };
      }
    });
  }

  function SearchData() {
    if (date.start > date.end) {
      /*const option = {
        ClosePopup: () => { setPopup(<></>); },
        type: 'message',
        message: '시작일이 종료일보다 늦습니다'
      };
      setPopup(<Popup option={option}/>);*/
      alert('시작일이 종료일보다 늦습니다');
      return;
    }

    const apiUrl = `${process.env.REACT_APP_API_DOMAIN}yeonoo/monitoring/raw-data?`;    
    setApiUrl(`${apiUrl}&startDate=${date.start}&endDate=${date.end}&equipmentName=${equipmentOption.value}&dataType=${dataTypeOption.value}&`);
  }

  function ChangeFullscreen() {
    if (document.fullscreenElement) {
      document.exitFullscreen();
      return;
    }

    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { //Firefox
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { //Chrome, Safari, Opera
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { //IE/Edge
      elem.msRequestFullscreen();
    }
  }

  function GetDateTime(firstDay) {
    const now = new Date();
    //now.setDate(now.getDate() - 1);
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); //월은 0부터 시작하므로 +1
    const day = firstDay ? '01' : String(now.getDate()).padStart(2, '0');
    const hours = firstDay ? '00' : String(now.getHours()).padStart(2, '0');
    const minutes = firstDay ? '00' : String(now.getMinutes()).padStart(2, '0');
    const seconds = '00'; //String(now.getSeconds()).padStart(2, '0') 초단위 설정 못하게 기본값 00

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  async function CreateExcel() {
    /*const response = await ApiGet(process.env.REACT_APP_API_DOMAIN + `raw-data/report/${dataTypeOption.value}?bizUnit=${bizUnit}&startDate=${date.start}&endDate=${date.end}&equipmentName=${equipmentOption.value}`);
    if (response !== null && response.ok) {
      const json = await response.json();

      if (json.length === 0) {
       
        alert('설정한 조회기간에 데이터가 없습니다');
        return;
      }

      //JSON to Excel 변환
      const worksheet = XLSX.utils.json_to_sheet(json); 

      //새 워크북 생성
      const workbook = XLSX.utils.book_new(); 

      //시트 추가
      XLSX.utils.book_append_sheet(workbook, worksheet, `${equipmentOption.label}_${dataTypeOption.label}`); 
    
      //Excel 파일 생성 및 다운로드
      XLSX.writeFile(workbook, `${equipmentOption.label}_${dataTypeOption.label}.xlsx`);  
    }*/
  }

  async function CreateCSV() {
    /*const response = await ApiGet(process.env.REACT_APP_API_DOMAIN + `raw-data/report/${dataTypeOption.value}?bizUnit=${bizUnit}&startDate=${date.start}&endDate=${date.end}&equipmentName=${equipmentOption.value}`);
    if (response !== null && response.ok) {
      const json = await response.json();

      if (json.length === 0) {

        alert('설정한 조회기간에 데이터가 없습니다');
      }

      //JSON to CSV 변환
      const csv = Papa.unparse(json);

      //CSV 데이터를 Blob으로 변환
      const bom = new Uint8Array([0xEF, 0xBB, 0xBF]); //UTF-8 BOM(Byte Order Mark), 엑셀 drag & drop 시 한글 깨짐 방지
      const blob = new Blob([bom, csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);

      //링크 및 파일명 설정
      const link = document.createElement('a');
      link.href = url;
      link.download = `${equipmentOption.label}_${dataTypeOption.label}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }*/
  }

  return (
    <div onContextMenu={(event)=>{ event.preventDefault(); }} style={{ userSelect: 'none', width: '100vw', height: '100vh', backgroundColor: backgroundMainColor }}>
      {popup}

      <div style={{ paddingTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <img src={logo} width={'200px'} height={'40px'} style={{ marginLeft: '0px', cursor: 'pointer' }} onClick={() => { window.location.hash = mainUrl[bizUnit]; }}/>
        
        <div style={{ height: 40, display: 'flex', gap: 5 }}>
          <div style={{ color: 'white', height: 40, fontSize: 20, lineHeight: 2.1 }}>조회기간</div>
          <input type='datetime-local' id='start' value={date.start} onChange={DateOnChange} style={{ borderRadius: 5, width: 180, lineHeight: 1, fontFamily: 'SCDream' }}/>
          <div style={{ color: 'white', height: 40, fontSize: 20, lineHeight: 1.8 }}>~</div>
          <input type='datetime-local' id='end' value={date.end} onChange={DateOnChange} style={{ borderRadius: 5, width: 180, lineHeight: 1, fontFamily: 'SCDream' }}/>

          <div style={{ width: 20 }}></div>

          <Select ref={equipmentSelectRef} options={equipmentOptions} onChange={EquipmentSelectChange} styles={searchStyles} placeholder='설비'/>
          <Select ref={dataTypeSelectRef} options={dataTypeOptions} onChange={DataTypeSelectChange} styles={searchStyles} placeholder='데이터 종류'/>

          <div style={{ width: 20 }}></div>

          <Search title='검색' width='23' height='23' fill='rgb(204,204,204)' style={{ position: 'relative', top: 8, cursor: 'pointer' }} onClick={SearchData}/>

          <div style={{ width: 20 }}></div>

          <CSV title='CSV 생성' width='23' height='23' fill='rgb(204,204,204)' style={{ position: 'relative', top: 8, cursor: 'pointer' }} onClick={CreateCSV}/>
          <Excel title='Excel 생성' width='23' height='23' fill='rgb(204,204,204)' style={{ position: 'relative', top: 8, cursor: 'pointer' }} onClick={CreateExcel}/>
        </div>

        <button title={document.fullscreenElement ? '최소화' : '최대화'} onClick={ChangeFullscreen} style={{ backgroundColor: backgroundMainColor, color: 'rgb(204,204,204)', border: 'none', fontSize: 30, width: 39, height: 30, cursor: 'pointer', lineHeight: 1 }}>◱</button>
      </div>
      
      <div style={{ backgroundColor: backgroundMainColor, height: `calc(100vh - 60px)`, padding: 20, boxSizing: 'border-box' }}>
          <PaginationGrid mainHeight={'60px'} longText={bizUnit === 3} inquiryCondition={true} apiUrl={apiUrl}/>          
      </div>
    </div>
  );
}

export default GwangjuRawData;